var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("The link you have used is not valid. Please contact technical support.")]):(_vm.ready)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }